import { CircularProgress, Grid } from "@mui/material";

export function Loading() {
  return (
    <Grid container justifyContent={"center"}>
      <CircularProgress />
    </Grid>
  );
}
